import { CheckCircleIcon, PrinterIcon, Send, XCircle } from "lucide-react";
import type React from "react";

interface Props {
    onPrint: () => void;
    onEmail: () => void;
    onClose: () => void;
}

const OrderCompletionModal: React.FC<Props> = ({
    onPrint,
    onEmail,
    onClose
}) => {
    return (
        <div
            className="fixed inset-0 flex items-center justify-center bg-black/50 z-50"
            onClick={onClose}
        >
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
                <div className="flex justify-end items-start mb-3">
                    <XCircle
                        onClick={onClose}
                        color="red"
                        className="hover:cursor-pointer"
                    />
                </div>

                <div className="my-4 text-center flex flex-col justify-center items-center">
                    <CheckCircleIcon
                        size={64}
                        color="green"
                        className="my-3"
                    />
                    <h2 className="text-xl font-bold">Purchase recorded successfully</h2>
                    <h2 className="text-lg font-semibold">Select your next action</h2>
                </div>

                <div className="flex justify-between">
                    <div>
                        <button
                            onClick={onClose}
                            className="px-4 py-2 border rounded-md text-gray-600 hover:bg-gray-100"
                        >
                            Cancel
                        </button>
                    </div>

                    <div className="flex gap-2">
                        <button
                            onClick={onPrint}
                            className="px-3 py-2 text-sm bg-primary text-white rounded-md hover:bg-blue-900 flex gap-2 items-center"
                        >
                            <PrinterIcon size={12} />
                            <span>Print Receipt</span>
                        </button>

                        <button
                            onClick={onEmail}
                            className="px-3 py-2 text-sm bg-green-600 text-white rounded-md hover:bg-green-700 flex gap-2 items-center"
                        >
                            <Send size={12} />
                            Send by Email
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderCompletionModal;